module.exports = __webpack_public_path__ + "static/media/Dolores Umbridge 1.f26e647b.jpg";